import { useEffect } from 'react';
import { 
    MinimizedCardDockDesktop, 
    MinimizedCardDockMobile 
} from './';
import { useDispatch } from 'react-redux';
import { minimized_content_groupActions } from '../../actions';
import { CONTENT_GROUP_ACTION } from '../../constants';
import { MinimizedCardActionCable } from './MinimizedCardActionCable';

const MinimizedCardDock = () => {
    const dispatch = useDispatch();
    const isUserLoggedIn = localStorage.getItem('user') ? true : false;

    useEffect(() => {
        console.log('Fetching minimized cards...');
        if (!isUserLoggedIn) return;

        const onSuccess = (response) => {
            const minimizedCards = response.data.data.minimized_cards;

            dispatch({
                type: CONTENT_GROUP_ACTION.SET_MINIMIZED_CARDS,
                payload: minimizedCards
            });
        };

        const params = {
            onSuccess,
            onError: (error) => console.error('Error fetching minimized cards:', error),
            onBefore: () => console.log('Fetching minimized cards...')
        };

        dispatch(minimized_content_groupActions.getMinimizedContentGroup(params));
    }, [isUserLoggedIn]); // Run at initial load and when isUserLoggedIn changes

    if (!isUserLoggedIn) {
        return null; // Don't render if user is not logged in
    }

    return (
        <>
            <MinimizedCardActionCable />
            <MinimizedCardDockDesktop />
            <MinimizedCardDockMobile />
        </>
    );
};

export { MinimizedCardDock };